<template>
  <div v-if="!programmingCategoryRatingPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="programmingCategoryRatingPresenter.chartOptions.value"
    :series="programmingCategoryRatingPresenter.chartSeries.value"
    type="radar"
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, SetupContext } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { dashboardTargetColor, programmingCategoryRatingChartColor } from '@/domain/value_objects/color/ColorList'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useDashboardModalStatePresenter } from '@/presentation/composables/dashboard/useDashboardModalStatePresenter'
import { useProgrammingCategoryRatingPresenter } from '@/presentation/composables/dashboard/useProgrammingCategoryRatingPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx: SetupContext) {
    const dashboardModalStatePresenter = useDashboardModalStatePresenter()
    const programmingCategoryRatingPresenter = useProgrammingCategoryRatingPresenter()
    const { isLightMode, displayLanguage } = useConfigStatePresenter()

    const initChart = () => {
      programmingCategoryRatingPresenter.initChart(
        dashboardModalStatePresenter.dashboardUserList.value,
        programmingCategoryRatingChartColor,
        dashboardTargetColor,
        dashboardModalStatePresenter.dashboardProgramLanguage.value,
        displayLanguage.value,
        isLightMode()
      )
    }

    onMounted(() => {
      // initChart()
    })

    return {
      initChart,
      programmingCategoryRatingPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
